var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25757 2.70596C1.25757 2.15367 1.70528 1.70596 2.25757 1.70596H11.7969C12.3492 1.70596 12.7969 2.15367 12.7969 2.70596V2.70596C12.7969 3.25824 12.3492 3.70596 11.7969 3.70596H2.25757C1.70528 3.70596 1.25757 3.25824 1.25757 2.70596V2.70596Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25757 6.70596C1.25757 6.15367 1.70528 5.70596 2.25757 5.70596H11.7969C12.3492 5.70596 12.7969 6.15367 12.7969 6.70596V6.70596C12.7969 7.25824 12.3492 7.70596 11.7969 7.70596H2.25757C1.70528 7.70596 1.25757 7.25824 1.25757 6.70596V6.70596Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25757 10.706C1.25757 10.1537 1.70528 9.70596 2.25757 9.70596H11.7969C12.3492 9.70596 12.7969 10.1537 12.7969 10.706V10.706C12.7969 11.2582 12.3492 11.706 11.7969 11.706H2.25757C1.70528 11.706 1.25757 11.2582 1.25757 10.706V10.706Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/MenuIcon.b59961bae7c4b3b353821aa1db252018.svg";
export { ForwardRef as ReactComponent };